<template>
  <div>
    <cabecera-web></cabecera-web>
    <div class="px-5 py-10 lg:px-20 xl:px-40" v-if="bonoActual">
      <div class="leading-10 info">
        <div class="contenido" v-html="contenidoActual"></div>
      </div>
      <!-- <component :is="componenteActual"></component> -->
    </div>
  </div>
</template>

<script>
import MasInformacion from "@/components/MasInformacion";
import MasInformacion_eu from "@/components/eu/MasInformacion";
import CabeceraWeb from "@/components/Cabecera";
import Condiciones from "@/components/Condiciones";
import Condiciones_eu from "@/components/eu/Condiciones";
import Final from "@/components/Final";
import Final_eu from "@/components/eu/Finaleu";

export default {
  data() {
    return {
      componentId: "MasInformacion",
      contenido: {
        "mas-informacion": "info",
        condiciones: "condiciones",
        final: "final",
      },
    };
  },
  props: ["idContenido"],
  components: {
    MasInformacion,
    MasInformacion_eu,
    CabeceraWeb,
    Condiciones,
    Condiciones_eu,
    Final,
    Final_eu,
  },
  computed: {
    contenidoActual() {
      const locale = this.locale;
      const idContenido = this.idContenido;
      const bonoActual = this.bonoActual;
      const componenteActual = this.contenido[idContenido];

      /// console.log('bonoActual', bonoActual)

      return bonoActual.contenido[locale][componenteActual];
    },
    locale() {
      return this.$i18n.locale;
    },
    bonoActual() {
      return this.$store.state.bonoActual;
    },
    componenteActual() {
      let componenteActual = this.idContenido;

      // const lang = this.$i18n.locale
      // if (lang=='eu') {
      //   componenteActual = componenteActual + '_eu'
      // }
      return componenteActual;
    },
  },
};
</script>